import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { architekturMythos } from './sections/architektur-mythos';
import { systemabsturz } from './sections/systemabsturz';
import { radikaleAkzeptanz } from './sections/radikale-akzeptanz';
import { feuerkindMoment } from './sections/feuerkind-moment';
import { faq } from './sections/faq';

export const content: BlogPostContent = {
  sections: [
    intro,
    architekturMythos,
    systemabsturz,
    radikaleAkzeptanz,
    feuerkindMoment,
    faq
  ]
};
